"use client";

import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";
import { Loader } from "ui/components";
import { useSession } from "next-auth/react";
import LocaleSwitcher from "@/i18n/LanguageSwitcher";
import { useAppConfiguration } from "appConfig";

const NewReservationPageContent = dynamic(
  () =>
    import("ui/reservation").then((module) => module.NewReservationPageContent),
  { ssr: false, loading: () => <Loader /> }
);

const PublicPageLayout = dynamic(
  () => import("ui/layout").then((module) => module.PublicPageLayout),
  { ssr: false, loading: () => <Loader /> }
);

export default function PriceSearchPage() {
  const t = useTranslations();
  const { data: session } = useSession();
  const appConfig = useAppConfiguration();

  return (
    <PublicPageLayout t={t} localeSwitcher={<LocaleSwitcher />}>
      <NewReservationPageContent
        t={t}
        session={session}
        appName={appConfig.appName}
      />
    </PublicPageLayout>
  );
}
